import React, { useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import {
  HIDE_RIGHT_PANEL_STATUS,
  LABELKEYS_SEARCH_RESULTS,
  NULL_VALUE,
  PUBLICATION_MEDIA_TYPE_NAME
} from "../../../helper/constants";
import QuickLinks from "../../pages/SearchResults/QuickLinks";
import MetaDataDisplay from "./MetaDataDisplay";
import { useSelector } from "react-redux";
import ViewAll from "./ViewAll";
import moment from "moment";
import { Link} from "react-router-dom";
import { Button_V2 } from "../Button_V2";

const MetaData = (props: any) => {
  const [searchMeataData, setSearchMetaData] = useState<any>([]);
  const [showText, setShowText] = useState(false);
  const [searchindex, setSearchIndex] = useState(Number);
  const [showMore, setShowMore] = useState(true);
  const [showClassName, setShowClassName] = useState([]);
  const [addtionalData, setAdditionalData] = useState<any>([]);
  const [attributes, setAttributes] = useState<any>([]);
  const [params, setParams] = useState<any>([]);
  const [isquicklinkTitleLink, setIsQuicklinkTitleLink] = useState(false);
  const [titleLinkStates, setTitleLinkStates] = useState<Record<number, boolean>>({});
  const [showHangarDownload, setShowHangarDownload] = useState<Record<number, boolean>>({});
  const [showTRDownload, setShowTRDownload] = useState<Record<number, boolean>>({});
  
  const configData = useSelector(
    (state: any) => state.config?.configData || {}
  );
  const { portalPermissions, loadingPortal, user_details } = useSelector(
    (state: any) => state.config
  );
  // const searchData =
  const showMoreVal = props.showMore !== undefined ? props.showMore : true;

  const formatData = (attribute, data, viewAll) => {
    let dataDisplay = data?._source[params[attribute.data]]
      ? data._source[params[attribute.data]]
      : NULL_VALUE;
    if (attribute.isFormatDate === true) {
      dataDisplay =
        data._source[params[attribute.data]] &&
        data._source[params[attribute.data]] !== undefined
          ? formatDate(data._source[params[attribute.data]])
          : NULL_VALUE;
    }

    if (attribute.extraParamData && attribute.extraParamData.length > 0) {
      for (let i = 0; i < attribute.extraParamData.length; i++) {
        dataDisplay =
          dataDisplay +
          attribute.extraParamSeparator[i] +
          attribute.extraParamPrefix[i] +
          data._source[params[attribute.extraParamData[i]]];
      }
    }
    // if (attribute.maxLength && viewAll === true) {
    //   dataDisplay = dataDisplay;
    // }
    if (
      attribute.searchCondition &&
      attribute.searchCondition != "" &&
      data._source[params[attribute.displayConditionalType[0]]] !== undefined &&
      data._source[params[attribute.displayConditionalType[0]]] !== null
    ) {
      const newAttrSearch =
        data._source[params[attribute.displayConditionalType[0]]];
      dataDisplay =
        dataDisplay.toLowerCase() == attribute.searchCondition.toLowerCase()
          ? dataDisplay
          : newAttrSearch[0][params[attribute.displayConditionalType[1]]];
    }

    return dataDisplay;
  };
  const handleIsTitleLink = (index: number) => {
    setTitleLinkStates((prevStates) => ({
      ...prevStates,
      [index]: true,
    }));
  };

  const resetIsTitleLink = (index: number) => {
     setTitleLinkStates((prevStates) => ({
      ...prevStates,
      [index]: false,
    }));
  };

 const handleHangarDownload = (index: number) => {
    setShowHangarDownload((prevState) => ({
      ...prevState,
      [index]: true, // Set showHangarDownload to true for the specific record
    }));
    };
  useEffect(() => {
    const anyTitleLink = Object.values(titleLinkStates).some((state) => state === true);
    if (isquicklinkTitleLink !== anyTitleLink) {
      setIsQuicklinkTitleLink(anyTitleLink);
    }

    setIsQuicklinkTitleLink(anyTitleLink);
    setShowText(false);
    setShowMore(showMoreVal);
    setParams(configData.NATIVE_SEARCH_API_PARAMS);
    
  

    if (
      props.searchData !== undefined &&
      props?.searchData?.hits?.total?.value > 0
    ) {
      if (showMoreVal === true) {
        setAttributes(props.attributes.slice(0, props.showMoreAttrLength));
        setAdditionalData(
          props.attributes.slice(
            props.showMoreAttrLength,
            props.attributes.length
          )
        );
      } else {
        setAttributes(props.attributes);
      }
       setSearchMetaData(props.searchData?.hits);
    }
  }, [props.searchData,titleLinkStates,isquicklinkTitleLink]);
 
  const showPartString = (str, strlength) => {
    let partString = "";

    if (str && str?.length > 0) {
      //let partString = str;
      //const ary1 = str.split(",");
      const ary1 = [...str];
      if (ary1.length > strlength) {
        partString = ary1.splice(0, strlength).join(", ");
      } else {
        partString =
          ary1.includes("N") && ary1.includes("A")
            ? ary1.toString().replace(/,/g, "")
            : ary1.join(",");
      }
    } else {
      partString = NULL_VALUE;
    }
    return partString;
  };

  const showMoreFiled = (index, isshow) => {
    setSearchIndex(index);
    setShowText(isshow);
  };

  const formatDate = (value) => {
    return moment(value).format("DD MMM Y");
    //const date = new Date(value.replace("T", " "));
    // const date = new Date(Date.parse(value));
    // const day = date.toLocaleString("default", { day: "2-digit" });
    // const month = date.toLocaleString("default", { month: "short" });
    // const year = date.toLocaleString("default", { year: "numeric" });
    // return day + " " + month + " " + year;
  };
  const { t } = useTranslation();

 //const replaceHypen = (text: string): string => {
    //return text ? text.replace(/-/g, "\u2011") : "";
  //};

  return (
    <div>
    
     {props?.searchData?.hits?.total?.value > 0 &&
        searchMeataData?.hits?.map((searchdata, index) => (
          <div className="record1 item" key={index}>
            <div className="seacrhresultLeft">
              {/* Title Hyperlink added for TRs also */}
{
 (props.type === "TR" &&
    searchdata?._source?.trMedia?.length > 0 &&
    searchdata?._source?.trMedia?.find(
      (item) =>
        item?.media_type_name &&
        PUBLICATION_MEDIA_TYPE_NAME?.includes(item?.media_type_name?.toLowerCase())
    ) &&
    (
      (portalPermissions?.result?.isInternal &&
        searchdata?._source?.export_lic_description?.toLowerCase() !== "license") ||
      (!portalPermissions?.result?.isInternal &&
        searchdata?._source?.is_subscription_flag)
    )
  ) ? (
    <div className="head-search cls-Title">
      <Link
        to=""
        aria-label="PubTitle"
        className="cls-MetaDataLink"
        onContextMenu={(e) => e.preventDefault()}
        onClick={e => {e.preventDefault(); setShowTRDownload(prev => ({ ...prev, [index]: true }));}}
      >
        {(searchdata?._source?.title)}
      </Link>
    </div>
  ) : (
    titleLinkStates[index] ? (
      <div className="head-search cls-Title">
        <Link
          to=""
          aria-label="PubTitle"
          className="cls-MetaDataLink"
          onContextMenu={(e) => e.preventDefault()}
       onClick={e => {
       e.preventDefault(); 
       handleHangarDownload(index); 
  }}
        >
          {(searchdata?._source?.title)}
        </Link>
      </div>
    ) : (
      <div className="head-search itemTitle">
        <h6>{(searchdata?._source?.title)}</h6>
      </div>
    )
  )
}

              {attributes?.map((item, attrIndex) => {
                return (
                   <>
                    <MetaDataDisplay
                      label={t(item?.label)}
                      data={formatData(item, searchdata, false)}
                      parseString={showPartString}
                      viewAllShow={
                        item.maxLength !== undefined &&
                        searchdata._source[params[item.data]] !== null &&
                        typeof searchdata._source[params[item.data]] ==
                          "object" &&
                        searchdata._source[params[item.data]].length >
                          item.maxLength
                      }
                      maxLength={
                        item.maxLength !== undefined ? item.maxLength : 0
                      }
                      pubId = {searchdata._source?.pub_uuid}                              
                    />
                  </>
                );
              })}
              {showMore === true && addtionalData.length > 0 && (
                <>
                  <div
                    className={
                      showMore !== true
                        ? ""
                        : showText && searchindex === index
                        ? "show-more"
                        : "show-less"
                    }
                  >
                    {addtionalData.map((item, attrIndex) => {
                      return (
                        <>
                          <MetaDataDisplay
                            label={t(item.label)}
                            data={formatData(item, searchdata, false)}
                            viewAllShow={
                              item.maxLength !== undefined &&
                              searchdata._source[params[item.data]] !== null &&
                              typeof searchdata._source[params[item.data]] ==
                                "object" &&
                              searchdata._source[params[item.data]].length >
                                item.maxLength
                            }
                            parseString={showPartString}
                            maxLength={
                              item.maxLength !== undefined ? item.maxLength : 0
                            }
                            attributeData={item.data}
                            pubId = {searchdata._source?.pub_uuid}         
                          />
                          {/* {item.maxLength !== undefined && typeof searchdata._source[params[item.data]]=='object' && searchdata._source[params[item.data]].length > item.maxLength  && <ViewAll data={formatData(item, searchdata, true)} />} */}
                        </>
                      );
                    })}
                  </div>
                </>
              )}

              {showMore === true && (
                <div className="sub-head1 shomorelink">
                  
                    {showText && searchindex === index ? (
                      <Button_V2
                      type="tertiary"
                      mode="default"
                      size="small"
                      onClick={() =>
                      showMoreFiled(index, !(showText && searchindex === index))}
                      iconAfter={
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-up" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
                        </svg>
                      }
                      
                    >
                      {t(LABELKEYS_SEARCH_RESULTS.SHOW_LESS)}
                    </Button_V2>
                      
                    ) : (
                      <Button_V2
                      type="tertiary"
                      mode="default"
                      size="small"
                      onClick={() =>
                      showMoreFiled(index, !(showText && searchindex === index))}
                      iconAfter={
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                        </svg>
                      }
                      
                    >
                      {t(LABELKEYS_SEARCH_RESULTS.SHOW_MORE)}
                    </Button_V2>
                      
                    )}{" "}
                  
                </div>
              )}
            </div>
            {searchdata?._source?.publication_status !== undefined &&
            HIDE_RIGHT_PANEL_STATUS.includes(
              searchdata?._source?.publication_status?.toLowerCase()
            ) ? (
              " "
            ) : props.type == "TR" ?
              (((portalPermissions?.result?.isInternal && searchdata?._source?.export_lic_description?.toLowerCase() !== "license") || (!portalPermissions?.result?.isInternal && searchdata?._source?.is_subscription_flag))
              && 
                <div>
                  <QuickLinks
                    data={searchdata}
                    searchResults={props?.searchData}
                    id={index}
                    seacrhVal={props.seacrchval}
                    type={props.type}
                    udc={searchdata?._source?.udc}
                    licFlag={searchdata?._source?.export_lic_description}
                    parentSubscriptionFlag={props.parentSubscriptionFlag}
                    subscriptionFlag={searchdata?._source?.is_subscription_flag}
                    fileStreamerParams={props.fileStreamerParams ? props.fileStreamerParams : ""}
                    isTitleData={() => handleIsTitleLink(index)} // Pass index-specific handler
                    resetIsTitleLink={() => resetIsTitleLink(index)} // Pass index-specific handler
                    hangarDownload={(value) =>
                    setShowHangarDownload((prevState) => ({
                      ...prevState,
                      [index]: value,
                    }))
                  }
                  isTrDownload={!!showTRDownload[index]}
                TrDownload={(val) => setShowTRDownload(prev => ({ ...prev, [index]: val }))}
                  />
                </div>
            ) : (
              <div className="rightpanel">
                <QuickLinks
                  data={searchdata}
                  searchResults={props?.searchData}
                  id={index}
                  seacrhVal={props.seacrchval}
                  type={props.type}
                  udc={searchdata?._source?.udc}
                  licFlag={searchdata?._source?.export_lic_description}
                  parentSubscriptionFlag={props.parentSubscriptionFlag}
                  subscriptionFlag={searchdata?._source?.is_subscription_flag}
                  fileStreamerParams={
                    props.fileStreamerParams ? props.fileStreamerParams : ""
                  }
                  isTitleData={() => handleIsTitleLink(index)} // Pass index-specific handler
                  resetIsTitleLink={() => resetIsTitleLink(index)} // Pass index-specific handler
                  hangarDownload={(value) =>
                  setShowHangarDownload((prevState) => ({
                    ...prevState,
                    [index]: value,
                  }))
                }
                isHangarDownload={!!showHangarDownload[index]}
              ></QuickLinks>
              </div>
            )}
          </div>
        ))}
    </div>
  );
};

export default MetaData;
